import ServiceCardsCart from './components/ServiseCardsCard/ServiceCardsCard';
import styles from './serviceCards.module.scss';
import { ServiceCardsType } from '@/types/serviceCards.types';

const ServiceCards = ({ cards, sectionTitle }: ServiceCardsType) => {
  return (
    <section className={styles.serviceCards}>
      <div className="container">
        {sectionTitle && (
          <h2
            className={styles.sectionTitle}
            dangerouslySetInnerHTML={{ __html: sectionTitle }}
          />
        )}
        <div className={styles.cardsContainer}>
          {cards.map((card) => (
            <ServiceCardsCart key={card.id} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCards;
